import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css'; // 全局样式

import Navbar from './components/Navbar'; // Navbar一般不需要懒加载，体积很小
import Navbar4GB from './components/Navbar4GB'; 
import Footer from './components/Footer'; // 导入Footer组件
import NotificationWebsite from './components/NotificationWebsite';

// 优化的加载组件
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    fontSize: '16px',
    color: '#666'
  }}>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #3498db',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <span>正在加载...</span>
    </div>
  </div>
);

// 错误边界组件
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('页面加载错误:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          flexDirection: 'column',
          gap: '10px'
        }}>
          <h3>页面加载失败</h3>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 16px',
              backgroundColor: '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            重新加载
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

// 页面组件懒加载
const Register = lazy(() => import('./components/Register'));
const Login = lazy(() => import('./components/Login'));
const ForgotPassword = lazy(() => import('./components/ForgotPassword'));
const Profile = lazy(() => import('./components/Profile/Profile'));
const MyMessages = lazy(() => import('./components/Profile/MyMessages'));

const UploadAudio = lazy(() => import('./components/Profile/UploadAudio'));
const LogoutPage = lazy(() => import('./components/LogoutPage'));
const Agreement = lazy(() => import('./components/Agreement'));

// 视频相关懒加载
// const VideoResources = lazy(() => import('./components/Video/VideoResources'));
// const VideoWatchPage = lazy(() => import('./components/Video/VideoWatchPage'));
// const VideoDetailPage = lazy(() => import('./components/Video/VideoDetailPage'));

// 音频相关懒加载
const AudioResources = lazy(() => import('./components/Audio/AudioResources'));
const UserAudios = lazy(() => import('./components/Profile/UserAudios'));
const MailboxWrite = lazy(() => import('./components/Profile/MailboxWrite'));
const MailboxList = lazy(() => import('./components/Profile/MailboxList'));
const UserCollections = lazy(() => import('./components/Profile/UserCollections'));
const CollectionDetail = lazy(() => import('./components/Profile/CollectionDetail'));
const PublicCollectionDetail = lazy(() => import('./components/Audio/PublicCollectionDetail'));
const AudioDetailPage = lazy(() => import('./components/Audio/AudioDetailPage'));
const AudioPlayer = lazy(() => import('./components/Audio/AudioPlayer'));
const ManualPage  = lazy(() => import('./components/Audio/ManualPage'));
const EditAudio = lazy(() => import('./components/Audio/EditAudio'));

import VideoList from './components/Video/VideoList';
import VideoPlayer from './components/Video/VideoPlayer';

// Layout4GBSystem 组件
const Layout4GBSystem = ({ children, showNavbar = true, showFooter = true  }) => (
  <>
    {showNavbar && <Navbar />}
    <div>{children}</div>
    {showFooter && <Footer />}
  </>
);

const Layout = ({ children, showNavbar = true, showFooter = true }) => (
  <>
    {showNavbar && <Navbar4GB />}
    <div>{children}</div>
    {showFooter && <Footer />}
  </>
);


//对于开发中的页面，提供一个统一的组件来显示“正在开发中”的信息（统一路由拦截）
const UnderDevelopment = () => (
  <Layout showNavbar={false}>
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>🚧 页面开发中</h2>
      <p>该功能正在开发中，敬请期待！</p>
    </div>
  </Layout>
);

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="app-container">
          <NotificationWebsite />
          <ErrorBoundary>
            <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Layout4GBSystem ><AudioResources /></Layout4GBSystem>} />
            <Route path="/register" element={<Layout4GBSystem><Register /></Layout4GBSystem>} />
            <Route path="/login" element={<Layout4GBSystem><Login /></Layout4GBSystem>} />
            <Route path="/forgot-password" element={<Layout4GBSystem><ForgotPassword /></Layout4GBSystem>} />           
            <Route path="/profile-upload" element={<Layout4GBSystem><Profile /></Layout4GBSystem>} />
            <Route path="/profile-upload-audio" element={<Layout4GBSystem><UploadAudio /></Layout4GBSystem>} />
            {/* <Route path="/education-resources" element={<Layout4GBSystem><VideoResources /></Layout4GBSystem>} /> */}
            <Route path="/broadcast-program" element={<Layout4GBSystem><AudioResources /></Layout4GBSystem>} />
            <Route path="/my-audios" element={<Layout4GBSystem><UserAudios /></Layout4GBSystem>} />
            <Route path="/mailbox-write" element={<Layout4GBSystem><MailboxWrite /></Layout4GBSystem>} />
            <Route path="/mailbox-list" element={<Layout4GBSystem><MailboxList /></Layout4GBSystem>} />
            <Route path="/messages/*" element={<Layout4GBSystem><MyMessages /></Layout4GBSystem>} />
            <Route path="/my-audio-collections" element={<Layout4GBSystem><UserCollections /></Layout4GBSystem>} />
            <Route path="/collection/:id" element={<Layout4GBSystem><CollectionDetail /></Layout4GBSystem>} />
            <Route path="/public-collection/:id" element={<Layout4GBSystem><PublicCollectionDetail /></Layout4GBSystem>} />
            {/* <Route path="/my-videos" element={<Layout4GBSystem><UserVideos /></Layout4GBSystem>} /> */}
            {/* <Route path="/video/:videoId" element={<Layout4GBSystem><VideoWatchPage /></Layout4GBSystem>} /> */}
            {/* <Route path="/user-videos/:videoId" element={<Layout4GBSystem><VideoDetailPage /></Layout4GBSystem>} /> */}
            <Route path="/user-audio/:audioId" element={<Layout4GBSystem><AudioDetailPage /></Layout4GBSystem>} />
            <Route path="/audio/:audioId" element={<Layout4GBSystem><AudioPlayer /></Layout4GBSystem>} />
            <Route path="/edit-audio/:audioId" element={<Layout4GBSystem><EditAudio /></Layout4GBSystem>} />
            <Route path="/agreement" element={<Layout4GBSystem><Agreement /></Layout4GBSystem>} />
            <Route path="/manual" element={<Layout4GBSystem><ManualPage /></Layout4GBSystem>} />
            {/* <Route path="/manual" element={<ManualPage />} /> */}
            <Route path="/logout" element={<LogoutPage />} />

            {/* 视频的页面 */}
            <Route path="/video-list" element={<Layout4GBSystem><VideoList /></Layout4GBSystem>} />
            <Route path="/video/:id" element={<Layout4GBSystem><VideoPlayer /></Layout4GBSystem>} />


            <Route path="/education-resources" element={<UnderDevelopment />} />
            <Route path="/user-videos/:videoId" element={<UnderDevelopment />} />
            <Route path="/video/:videoId" element={<UnderDevelopment />} />
            <Route path="/programs" element={<UnderDevelopment />} />
            <Route path="/programs" element={<UnderDevelopment />} />
            <Route path="/news" element={<UnderDevelopment />} />
            <Route path="/public-welfare-store" element={<UnderDevelopment />} />
            <Route path="/join-us" element={<UnderDevelopment />} />

          </Routes>
          </Suspense>
          </ErrorBoundary>
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
